import { useState } from "react";
import { useTranslations } from "@jugl-web/utils";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { LoadingSpinner } from "@jugl-web/ui-components";
import { ReactComponent as OptIcon } from "./assets/otp.svg";
import { WorkspaceTile } from "../WorkspaceTile";
import { WorkspaceOtpDisableDialog } from "./components/WorkspaceOtpDisableDialog";

export const WorkspaceOtp = () => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const { t } = useTranslations();
  const { entitiesApi } = useRestApiProvider();
  const { entity } = useEntitySelectedProvider();
  const { data: entitySettings, isLoading } =
    entitiesApi.useGetEntitySettingsQuery({
      entityId: entity.id,
    });

  const isEnabled = entitySettings?.task.customer_auth === "enabled";

  return (
    <>
      <WorkspaceTile
        onClick={() => setDialogIsOpen(true)}
        tooltipText={t({
          id: "workspace-page.workspace-otp-tooltip-3",
          defaultMessage:
            "When sharing guest URL of Task,  external users should go through additional authentication by entering an OTP (One Time Password)ℹ️ You can enable or disable this setting any time",
        })}
        buttonText={
          isEnabled
            ? t({
                id: "common.disable",
                defaultMessage: "Disable",
              })
            : t({
                id: "common.enable",
                defaultMessage: "Enable",
              })
        }
      >
        <div className="text-center duration-500 group-hover:-translate-y-11">
          <OptIcon />
          <div className="mt-3 flex flex-col gap-1.5 text-center">
            <span className="font-medium text-dark-800">OTP for Guest URL</span>
            {isLoading && <LoadingSpinner size="sm" color="grey" />}
            {!isLoading && (
              <span className="text-sm text-[#828282]">
                {isEnabled
                  ? t({
                      id: "workspace-page.workspace-otp-enabled-status",
                      defaultMessage: "Enabled ✅",
                    })
                  : t({
                      id: "workspace-page.workspace-otp-disabled-status",
                      defaultMessage: "Disabled ❌",
                    })}
              </span>
            )}
          </div>
        </div>
      </WorkspaceTile>
      <WorkspaceOtpDisableDialog
        isOpen={dialogIsOpen}
        onRequestClose={() => setDialogIsOpen(false)}
        isEnabled={isEnabled}
      />
    </>
  );
};
